export function SentDot({s}) {
  const c=s==="positive"?"#22c55e":s==="negative"?"#ef4444":"#f59e0b";
  const l=s==="positive"?"Positive":s==="negative"?"Critical":"Neutral";
  return <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:11,color:c,fontWeight:600}}><span style={{width:6,height:6,borderRadius:"50%",background:c,display:"inline-block"}}/>{l}</span>;
}

export default SentDot;
